var DK = DK || {};
DK.HandlebarSliders = {
  diameterMap: new Map(),
  overallwidthMap: new Map(),
  centerwidthMap: new Map(),
  riseMap: new Map(),
  pullbackMap: new Map(),
  mmSuffix: 'mm',
  impSuffix: '"',
  init: function () {
    DK.HandlebarSliders.initSelects();
    DK.HandlebarSliders.createMaps();
    DK.HandlebarSliders.initSliders(this.impSuffix);
    DK.HandlebarSliders.initEvents();
  },
  initEvents: function () {
    const $form = $('form.hb-facet__form');

    //Hitting the apply button sends ajax request
    $form.on('submit', function (e) {
      e.preventDefault();
      const form = $(e.target),
        measurement = form.find('[data-measure]').data('measure');
      DK.HandlebarSliders.sendHandlebarInfo(form, measurement);
    });

    //Toggling unit button group changes measurement units
    $('[data-unit]').on('click', function () {
      const measurement = $(this).parents('form').find('[data-measure]').data('measure');
      const clickedUnit = $(this).data('unit');
      DK.HandlebarSliders.switchUnits(clickedUnit, measurement);
    });

    //Selecting new options in the mix and max select lists
    $('.hbf__min, .hbf__max').on('change', function () {
      DK.HandlebarSliders.changeSelect($(this));
    });

    //Evaluate select values on initialization
    let selects = $form.find('select');
    selects.each(function (i, e) {
      let select = $(e);
      DK.HandlebarSliders.evaluateSelects(select);
    });
  },
  initSliders: function (unit) {
    $('.hb-facet__form input.hb-facet__slider').each(function (i, e) {
      let textArray = [],
        textValue;
      const slider = $(e),
        measurementName = slider.parents('[data-measure]').data('measure');
      const selectedMap = DK.HandlebarSliders._returnSelectedMap(measurementName);
      /* IonRange determines the position of slider handles based
      	on the index of the selected value */
      const from = slider.parent().siblings().find('select:first option[selected]').index(),
        to = slider.parent().siblings().find('select:last option[selected]').index();
      const sliderInstance = slider.data('ionRangeSlider');

      //Make an array out of map keys or values depending on unit
      selectedMap.forEach((value, key) => {
        textValue = unit === 'mm' ? key : value;
        textArray.push(textValue);
      });
      if (sliderInstance) {
        //Used for unit changes
        sliderInstance.update({
          postfix: unit,
          values: textArray
        });
      } else {
        slider.ionRangeSlider({
          type: 'double',
          skin: 'flat',
          from: from,
          to: to,
          min: 0,
          max: to,
          force_edges: true,
          postfix: unit,
          grid_snap: true,
          values: textArray,
          onFinish: function (data) {
            DK.HandlebarSliders.updateSelects(data);
          }
        });
      }
    });
  },
  updateSliders: function ($select) {
    let self = this;
    let textArray = [];
    const measurement = $select.parents('[data-measure]').data('measure'),
      isMetric = $select.parents('form').find('.hb-metric').val();
    const unit = isMetric === 'true' ? self.mmSuffix : self.impSuffix;
    const selectedMap = DK.HandlebarSliders._returnSelectedMap(measurement);

    //IonRangeSlider wants an array of values, so create array from map
    selectedMap.forEach((value, key) => {
      textValue = unit === 'mm' ? key : value;
      textArray.push(textValue);
    });
    const sliderInstance = $select.parents('[data-measure]').find('.hb-facet__range-slider input').data('ionRangeSlider');
    if (sliderInstance) {
      //Used for unit and powersport changes
      sliderInstance.update({
        postfix: unit,
        values: textArray
      });
    }
  },
  initSelects: function () {
    const measurements = $('.hb-facet__form [data-measure]');

    //Select the min and maxes for each measurement
    $.each(measurements, function (i, e) {
      const selects = $(e).find('select');
      const minValue = selects.first().children('[selected]').val(),
        maxValue = selects.last().children('[selected]').val();

      // Auto select the lowest min value and highest max value
      selects.first().prop('value', minValue);
      selects.last().prop('value', maxValue);
    });
  },
  updateSelects: function (data) {
    //Updates the selects to reflect the slider changes
    const parentMeasurement = data.input.parents('[data-measure]').data('measure'),
      measurementSelector = $(`[data-measure='${parentMeasurement}']`),
      selects = measurementSelector.find('select');
    let minSelect, maxSelect;

    //Remove currently selected option
    selects.children().removeAttr('selected');

    //Change selects to the new min and max values
    selects.each(function (i, e) {
      if ($(e).hasClass('hbf__min')) {
        minSelect = $(e);

        /* Hackery to search for the values, minus the unit. */
        let filterMin = minSelect.children().filter(function () {
          return $(this).text().replace(/\"|mm/g, '') === data.from_value.toString();
        });

        /* We only want to fire the change event on the select that was changed,
        	otherwise it'll send two ajax requests */
        if (minSelect.val() !== filterMin.val()) {
          minSelect.prop('value', filterMin.val()).trigger('change');
        }
      } else {
        maxSelect = $(e);
        /* Hackery to search for the values, minus the unit. */
        let filterMax = maxSelect.children().filter(function () {
          return $(this).text().replace(/\"|mm/g, '') === data.to_value.toString();
        });
        if (maxSelect.val() !== filterMax.val()) {
          maxSelect.prop('value', filterMax.val()).trigger('change');
        }
      }
    });
  },
  changeSelect: function ($select) {
    let allSelects;
    const parentMeasurement = $select.parents('[data-measure]').data('measure'),
      measurementSelector = $(`[data-measure='${parentMeasurement}']`);
    const newValue = $select.val();
    const selectFunction = function (thisSelect) {
      thisSelect.children().removeAttr('selected');
      thisSelect.find(`option[value='${newValue}']`).attr('selected', '');
      DK.HandlebarSliders.updateSliders(thisSelect);
      DK.HandlebarSliders.evaluateSelects(thisSelect);
    };

    /*Since there is usually a top and let slider for each measurement
    	they need to be in sync with eachother*/
    if ($select.hasClass('hbf__min')) {
      //Make min selects match
      allSelects = measurementSelector.find('select.hbf__min');
      allSelects.each(function () {
        selectFunction($(this));
      });
    } else if ($select.hasClass('hbf__max')) {
      //Make max selects match
      allSelects = measurementSelector.find('select.hbf__max');
      allSelects.each(function () {
        selectFunction($(this));
      });
    }
  },
  evaluateSelects: function ($selector) {
    let selectOption = null,
      minIndex,
      maxIndex;
    const parent = $selector.parent();
    const $minValue = parent.find('.hbf__min').val(),
      $maxValue = parent.find('.hbf__max').val();

    /* This little gem makes sure you can't select a min value that's
    higher than the max or a max value lower than the min. So once you select
    either a min or max it'll hide the values over or under that value. */
    if ($selector.hasClass('hbf__min')) {
      const maxOptions = parent.find('.hbf__max').children();
      maxOptions.show().removeAttr('disabled');
      for (let i = 0; i < maxOptions.length; i++) {
        if (maxOptions.eq(i).val() === $minValue) {
          selectOption = maxOptions[i];
          maxIndex = selectOption.index;
          break;
        }
      }
      $(selectOption).prevAll().hide().attr('disabled');
    } else {
      const minOptions = parent.find('.hbf__min').children();
      minOptions.show().removeAttr('disabled');
      for (let i = 0; i < minOptions.length; i++) {
        if (minOptions.eq(i).val() === $maxValue) {
          selectOption = minOptions[i];
          minIndex = selectOption.index;
          break;
        }
      }
      $(selectOption).nextAll().hide().attr('disabled');
    }
    const sliderInstance = parent.parent().find('.hb-facet__slider').data('ionRangeSlider');
    if (sliderInstance !== undefined) {
      sliderInstance.update({
        from: maxIndex,
        to: minIndex
      });
    }
  },
  getHandlebarParameterName: function (measurement) {
    //Determine param name in order to build URL
    let paramName;
    if (measurement === 'centerwidth') {
      paramName = 'handlebarCenterWidth';
    } else if (measurement === 'rise') {
      paramName = 'handlebarRise';
    } else if (measurement === 'diameter') {
      paramName = 'handlebarDiameter';
    } else if (measurement === 'overallwidth') {
      paramName = 'handlebarOverallWidth';
    } else if (measurement === 'pullback') {
      paramName = 'handlebarPullback';
    }
    return paramName;
  },
  sendHandlebarInfo: function ($form, measurement) {
    const paramName = DK.HandlebarSliders.getHandlebarParameterName(measurement);
    const minRange = $form.find('select:first').val(),
      maxRange = $form.find('select:last').val();
    const url = new URL(window.location.href);
    url.searchParams.set(paramName, minRange + '-' + maxRange);
    DK.Search.updateListing(url.pathname + url.search, $form.serialize(), $form.offset().top - 400);
  },
  //Switching the units to either metric or imperial
  switchUnits: function (clickedUnit, measurement) {
    const self = this;
    const measurementSelector = $(`[data-measure='${measurement}']`),
      metricInput = measurementSelector.parents('form').find('input.hb-metric'),
      unitInput = measurementSelector.next().find(`label[data-unit='${clickedUnit}']`).prev('input');
    const unit = clickedUnit === 'metric' ? self.mmSuffix : self.impSuffix;
    const selectLists = measurementSelector.find('select'),
      selectedMin = selectLists.first().children(':selected').val(),
      selectedMax = selectLists.last().children(':selected').val();

    //Change the input value based on the unit
    clickedUnit === 'metric' ? metricInput.attr('value', true) : metricInput.attr('value', false);
    //Remove all the options
    selectLists.children().remove();

    //Retrieve the specific measurement's map
    let selectedMap = DK.HandlebarSliders._returnSelectedMap(measurement);

    //Readd the options with the selected measurement unit
    selectedMap.forEach((value, key) => {
      const textValue = unit === 'mm' ? key : value;
      $('<option />').attr('value', key).html(textValue + unit).appendTo(selectLists);
    });

    //Reselect previous selected options after changing units.
    measurementSelector.find('select.hbf__min').prop('value', selectedMin).trigger('change');
    measurementSelector.find('select.hbf__max').prop('value', selectedMax).trigger('change');

    //Make sure the correct button toggle is selected on the top and left
    //button groups
    $.each(unitInput, function (i, e) {
      $(e).prop('checked', 'checked').siblings('input').removeAttr('checked');
    });
  },
  /* Create maps of measurements. That way we have the data
  when the user wants to switch units, etc. To get the maps
  it needs the values and text of the options populated on
  pageload */
  createMaps: function () {
    const self = this;
    const measurement = $('.hb-facet__form [data-measure]');

    //Reset the maps if they're already there and need to be updated
    self.diameterMap = new Map();
    self.overallwidthMap = new Map();
    self.centerwidthMap = new Map();
    self.riseMap = new Map();
    self.pullbackMap = new Map();
    $.each(measurement, function (i, e) {
      const options = $(e).find('select:first').children();
      const measurementName = $(e).data('measure');
      $.each(options, function (i, e) {
        const newText = $(e).text().replace(/\"/g, ''),
          newValue = $(e).val();
        switch (measurementName) {
          case 'centerwidth':
            self.centerwidthMap.set(newValue, newText);
            break;
          case 'rise':
            self.riseMap.set(newValue, newText);
            break;
          case 'diameter':
            self.diameterMap.set(newValue, newText);
            break;
          case 'overallwidth':
            self.overallwidthMap.set(newValue, newText);
            break;
          case 'pullback':
            self.pullbackMap.set(newValue, newText);
            break;
        }
      });
    });
  },
  //Helper Function to return the current Map
  _returnSelectedMap: function (measurement) {
    const self = this;
    switch (measurement) {
      case 'centerwidth':
        return self.centerwidthMap;
      case 'rise':
        return self.riseMap;
      case 'diameter':
        return self.diameterMap;
      case 'overallwidth':
        return self.overallwidthMap;
      case 'pullback':
        return self.pullbackMap;
    }
  }
};
$(function () {
  DK.HandlebarSliders.init();
});